import React, {Component} from 'react';
import {request} from "../../util/APIUtils";
import Table from "../../components/Table/Table";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import {API_BASE_URL} from "../../constants";
import Alert from "react-s-alert";
import LoadingIndicator from "../../common/LoadingIndicator";
import {Button, Dropdown, Menu} from 'antd';
import { showAxiosError } from '../../util/Helpers';
import { Link } from 'react-router-dom/cjs/react-router-dom';

class NewSurveyListPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            surveys: [],
            survey: null,
            error: null,
            loading: false,
            page: 0,
            currentPage: 1,
            pageSize: 10,
            selectedSurvey:null,
            add: false,
            currentUser:[],
            userId: null,
            selectedItem: null,

            totalIdList: [],
           // debtList: [],
            searching: false,
            searchQuery: undefined,
            total: 0,
            size: 10,
            isEditModalOpen: false,
            // addNoteModal: false,
            // addIncomingModal: false,
            // addTransferModal: false,
            addDeleteModal: false,
            mode: this.props.location.mode,
           // action: '',
            isLoading: false,
        };
        this.handleSearch = this.handleSearch.bind(this);
        this.addNew = this.addNew.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleMenuClick = this.handleMenuClick.bind(this);
        this.fetchSurveys = this.fetchSurveys.bind(this);
    }


    componentDidMount() {
        this.fetchSurveys()
    }



    fetchSurveys(page, size, accessor, direction) {
        let sortStr = accessor ? `&sort=${accessor},${direction}` : "&sort=id,asc";
        let searchQuery = this.state.searchQuery ? `&${this.state.searchQuery}` : '';
        let url = `${API_BASE_URL}/anket?page=${page}&size=${size}${sortStr}${searchQuery}`;
    
        this.setState({ loading: true, searching: true });
    
        request({ url: url, method: "get" })
            .then(response => {
                let totalChanged = response.data.totalElements !== this.state.total;
                this.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    surveys: response.data.content,
                    totalIdList: response.data.content.map(survey => survey.id),
                    loading: false,
                    searching: !totalChanged,
                });
            })
            .catch(error => {
                this.setState({ loading: false, searching: false, error: "Anketler yüklenirken bir sorun oluştu." });
                showAxiosError(error);
            });
    }
    
    handleSurveyDelete = (id, title) => {
        const isConfirmed = window.confirm(`"${title}" Anketini silmek istediğinizden emin misiniz?`);
    
        if (isConfirmed) {
            const token = localStorage.getItem("accessToken");
            const apiUrl = `${API_BASE_URL}/anket/${id}`;
    
            fetch(apiUrl, {
                method: "DELETE",
                headers: {
                    Authorization: "Bearer " + token,
                },
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    this.setState((prevState) => ({
                        surveys: prevState.surveys.filter((survey) => survey.id !== id),
                    }));
                })
                .catch((error) => {
                    console.error("There was a problem with the fetch operation:", error.message);
                });
        }
    };
    
    handleEditSurvey = (editedSurvey) => {
        const token = localStorage.getItem("accessToken");
        const url = `${API_BASE_URL}/anket/${editedSurvey.id}`;
        let data = editedSurvey;
    
        const params = {
            url: url,
            method: "PUT",
            headers: {
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
            },
            data: data,
        };
    
        request(params)
            .then((response) => {
                if (response.status === 200) {
                    const message = "Anket başarıyla güncellendi!";
                    Alert.success(message, {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                    this.fetchSurveys(this.state.page, this.state.pageSize);
                    this.setState({ isModalVisible: false });
                } else {
                    const message = "Anket güncellenemedi. Lütfen tekrar deneyin.";
                    console.error("Unexpected response status:", response.status);
                    Alert.error(message);
                }
            })
            .catch((error) => {
                const message = "Anket güncellenirken bir hata oluştu. Lütfen tekrar deneyin.";
                console.error("Anket güncellenirken bir hata oluştu:", error);
                Alert.error(message);
            });
    };
    

    handleLogout() {
        this.props.handleLogout();
    }

    cancelSurveyCreation() {
        this.setState({
            isEditModalOpen: false,
            addDeleteModal: false,
            add:false,
        })
        this.fetchSurveys()
    }
    handleEdit(item) {
        this.setState({
            selectedSurvey: item,
            isEditModalOpen: true,
        })
    }
    handleDelete(item) {
        this.setState({
            selectedSurvey: item,
            addDeleteModal: true
        });
    }
    

    addNew(item) {
        this.setState({
            selectedSurvey: null,
            isEditModalOpen: true,
            add:true
        })
    }
    handleSearch(searchQuery, fromForm) {
        let page = 0;
        if (fromForm) {
            page = this.state.page;
        }
        this.setState({
            searchQuery,
            searching: true,
        }, () => this.fetchSurveys(this.state.accessor, this.state.direction, page, this.state.size))
    }

    // handleMenuClick(e) {
    //     let self = this;
    //     if (e.key === '1') {
    //         this.handleEdit(self.state.selectedItem);
    //     } else if (e.key === '2') {
    //         this.handleDelete(self.state.selectedItem);
    //     }
    // }


    handleMenuClick(e) {
        if (e.key === '1') {
            this.handleEdit(this.state.selectedItem);
        } else if (e.key === '2') {
            this.handleDelete(this.state.selectedItem);
        }
    }


   
    


    render() {
        const {
            match: { params },
          } = this.props;

        const columns = [
            {
                Header: "Anket Başlığı",
                accessor: "title",
            },
            {
                Header: "Başlangıç Tarihi",
                accessor: "startDate",
                Cell: (item) => (
                    <label>{new Date(item.startDate).toLocaleDateString("tr")}</label>
                                  ),
            },
            {
                Header: "Bitiş Tarihi",
                accessor: "endDate",
                Cell: (item) => (
                    <label>{new Date(item.endDate).toLocaleDateString("tr")}</label>
                                  ),
            },
            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: item => (
                    <div>
                        <Button style={{
                            background: '#3b6b96',
                            height: '30px',
                            width: '100px',
                            color: 'white',
                            borderRadius: '0.375em',
                            fontSize: "12px",
                        }}>
                            <Link to={`/anket/${item.id}`}>Ankete Katıl</Link>
                        </Button>
                    </div>
                )
            }
        ];



        const fields = [
            {
                label: "Anket Başlığı",
                accessor: "title",
                type: "text",
                operator: "=",
            },
        ];

        return (
            <div className="row baseBackground">
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className="col-md-12 satirBasi">
                    <div className="card-header ">
                        <h4 className="card-title">Anketler</h4>
                    </div>
                    <div className="card-body mt-1">
                        <div className=" ">
                            <div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
                                <DetailedSearch
                                    fields={fields}
                                    loading={this.state.searching}
                                    onSearch={this.handleSearch}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <Table
                            loading={this.state.loading}
                            loadingText="Kayıtlar getiriliyor..."
                            content={this.state.surveys}
                            total={this.state.total}
                            page={this.state.page}
                            // manual={this.state.manual}
                            size={this.state.size}
                            options={["5", "10", "20", "50", "100"]}
                            columns={columns}
                            fetchData={this.fetchSurveys}
                            style={{ width: "100%" }}
                        />
                    </div>
                </div>
            </div>
        )
    }
}






export default NewSurveyListPage;


// WEBPACK FOOTER //
// ./src/page/surveypage/NewSurveyListPage.js